import { render, staticRenderFns } from "./BatchBillingListEditor.yaml?vue&type=template&id=f1afdf60&component"
import script from "./BatchBillingListEditor.yaml?vue&type=script&lang=ts&component"
export * from "./BatchBillingListEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports